module.exports = __webpack_public_path__ + "img/公司新闻(1).6083a662.jpg";